export const player1Color = "#ff2647";
export const player2Color = "#42eff5";

export const PLAYER_1_DEPLOYMENT = 6;
export const PLAYER_2_DEPLOYMENT = 11;

export const CORE_RULES = [
  {
    title: "Kill Box",
    text: `Starting on player 2's 2nd turn, the opponent
    scores 2 VP if your Leader model is
    completely within 12" of your table edge at the
    end of your turn. Scenarios use the Kill Box
    rule unless otherwise stated.`,
  },
  {
    title: "Objectives",
    text: ``,
  },
  ,
];

export const SCENARIO_OPTIONS = [
  {
    label: "1 Recon",
    value: "recon",
  },
  {
    label: "2 Battle Lines",
    value: "battleLines",
  },
  {
    label: "3 Wolves At Our Heels",
    value: "wolvesAtOurHeels",
  },
  {
    label: "4 Payload",
    value: "payload",
  },
  {
    label: "5 Two Fronts",
    value: "twoFronts",
  },
  {
    label: "6 Invasion",
    value: "invasion",
  },
];

export const OBJECTIVES = {
  ["30"]: {
    label: "30",
    zone: 3,
    scoredBy: "leader, solo",
  },
  ["40"]: {
    label: "40",
    zone: 3,
    scoredBy: "leader, unit",
  },
  ["50"]: {
    label: "50",
    zone: 3,
    scoredBy: "leader, cohort, battle engine",
  },
  ["flag"]: {
    label: "flag",
    zone: 2,
  },
  ["cache"]: {
    label: "cache",
    zone: 0,
  },
};

export const SCENARIOS = {
  recon: {
    objectives: [
      {
        type: "30",
        player: 1,
        right: 18,
        bottom: 18,
      },
      {
        type: "30",
        player: 2,
        right: 18,
        bottom: 18,
      },
      {
        type: "cache",
        left: 23,
        bottom: 20,
        player: 1,
      },
      {
        type: "cache",
        left: 23,
        bottom: 18,
        player: 2,
      },
      {
        type: "flag",
        left: 12,
        bottom: 23,
        player: 1,
      },
      {
        type: "flag",
        left: 12,
        bottom: 23,
        player: 2,
      },
    ],
  },

  battleLines: {
    rules: [
      `- After scoring, the active player must move any one Objective 3" towards the opponent’s table edge.`,
      `- Cannot move same Objective as opponent did last turn.`,
    ],
    objectives: [
      {
        type: "30",
        player: 1,
        right: 9,
        bottom: 20,
      },
      {
        type: "30",
        player: 2,
        right: 9,
        bottom: 20,
      },
      {
        type: "40",
        player: 1,
        right: 20,
        bottom: 23,
      },
      {
        type: "40",
        player: 2,
        right: 20,
        bottom: 23,
      },
      {
        type: "flag",
        player: 1,
        left: 12,
        bottom: 19,
      },
      {
        type: "flag",
        player: 2,
        left: 12,
        bottom: 19,
      },
    ],
  },

  wolvesAtOurHeels: {
    rules: [
      `- After player 1's 3rd turn, Kill Box extends 2" every round.`,
      `- After scoring, each player must move each secured 40mm Objective 3" toward the opponent’s table edge.`,
      `- At the end of player 2's 4th turn, the player with the furthest 40mm Objective scores 3 VP once.`,
    ],
    objectives: [
      {
        type: "40",
        player: 1,
        left: 8,
        bottom: 15,
      },
      {
        type: "40",
        player: 2,
        left: 8,
        bottom: 15,
      },
      {
        type: "50",
        player: 1,
        left: 19,
        top: 23,
      },
      {
        type: "50",
        player: 2,
        left: 19,
        top: 23,
      },
      {
        type: "cache",
        player: 1,
        right: 12,
        bottom: 20,
      },
      {
        type: "cache",
        player: 2,
        right: 16,
        bottom: 16,
      },
    ],
  },

  payload: {
    rules: [
      `- Flags do not score VPs.`,
      `- After scoring, players must move each secured 50mm Objective 3+1", per secured 30/40mm Objectives, towards their opponent’s Objective Terrain.`,
      `- After moving a 50mm Objective, that player may move one friendly Cohort model 5" directly towards it.`,
      `- When a 50mm Objective ends within 2" of the opponent’s Objective Terrain, score 5 VP and remove the 50mm Objective and Flag.`,
    ],
    objectives: [
      {
        type: "30",
        player: 2,
        right: 8,
        bottom: 20,
      },
      {
        type: "40",
        player: 1,
        right: 20,
        bottom: 20,
      },
      {
        type: "40",
        player: 2,
        right: 20,
        bottom: 20,
      },
      {
        type: "50",
        player: 1,
        right: 9,
        bottom: 16,
      },
      {
        type: "50",
        player: 2,
        right: 9,
        bottom: 16,
      },
      {
        type: "flag",
        player: 1,
        left: 16,
        bottom: 19,
      },
      {
        type: "flag",
        player: 2,
        left: 16,
        bottom: 19,
      },
    ],
  },

  twoFronts: {
    rules: [
      `- No Kill Box.`,
      `- A player that secures both 40mm or both 50mm Objectives, scores an additional 2 VP at the end of each turn.`,
    ],
    objectives: [
      {
        type: "30",
        player: 2,
        right: 22.6,
        bottom: 20,
      },
      {
        type: "40",
        player: 1,
        left: 10,
        bottom: 20,
      },
      {
        type: "40",
        player: 2,
        right: 10,
        bottom: 20,
      },
      {
        type: "50",
        player: 1,
        right: 12,
        bottom: 18,
      },
      {
        type: "50",
        player: 2,
        left: 12,
        bottom: 18,
      },
    ],
  },

  invasion: {
    rules: [
      `- After scoring, players may move each secured enemy Objective 5" in any direction.`,
      `- Objectives may not end within 3" of table edges.`,
      `- First player to end with an opponent’s Objective within their own deployment zone scores 5 VP.`,
    ],
    objectives: [
      {
        type: "40",
        player: 1,
        right: 5,
        bottom: 22,
      },
      {
        type: "40",
        player: 2,
        right: 5,
        bottom: 22,
      },
      {
        type: "50",
        player: 1,
        left: 20,
        bottom: 20,
      },
      {
        type: "50",
        player: 2,
        left: 20,
        bottom: 20,
      },
      {
        type: "flag",
        player: 1,
        left: 14,
        top: 14,
      },
      {
        type: "flag",
        player: 2,
        top: 14,
        left: 14,
      },
    ],
  },
};
